'use strict';

module.exports = {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile',
};



// WEBPACK FOOTER //
// ./assets/js/global/constants/deviceTypes.es.js